module.exports = __webpack_public_path__ + "img/rock01.87217d1e.png";